import React, { useCallback, useEffect, useState } from 'react';
import { Route, Routes, useLocation, useMatch } from 'react-router-dom';
//import AppRoutes from './AppRoutes';
import { LayoutRoute } from './components/Layout';
import { Intake } from "./components/Intake";
import { IntakeComplete } from "./components/IntakeComplete";
import { ErrorClinic } from './components/ErrorClinic';
import { useIntakeAlertService } from './services/IntakeAlertService'
import { useClinicService } from './services/ClinicService';

export const App = () => {
  const { GetAlert } = useIntakeAlertService()
  const { GetBusinessUnit } = useClinicService()
  //const alertRef = useRef({hasAlert: false})

  const matchIntakeComplete = useMatch('/intakeComplete')
  const matchRoot = useMatch('/')
  const location = useLocation()

  const [alert, setAlert] = useState({hasAlert: false})
  const [businessUnit, setBusinessUnit] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    App.displayName = App.name;
  }, [])

  const loadAlertAndBusinessUnitData = useCallback(async () => {

    const clinicUniqueId = location.pathname && location.pathname.substring(1)

    const [currentAlert, businessUnit] = await Promise.all([
      GetAlert(),
      GetBusinessUnit(clinicUniqueId)
    ])

    //alertRef.current = alert
    setAlert(currentAlert)
    setBusinessUnit(businessUnit)
    setIsLoading(false)
  }, [ location, GetAlert, GetBusinessUnit, setAlert, setBusinessUnit, setIsLoading])

  const cheeseTheLogo = useCallback(async () => {
    setBusinessUnit({ isWhiteLabel: false })
    setIsLoading(false)
  }, [setBusinessUnit])

  useEffect(() => {
    if (isLoading) {
      if (!(matchIntakeComplete || matchRoot)) {
        loadAlertAndBusinessUnitData()
      }
      else {
        cheeseTheLogo()
      }
    }
  }, [loadAlertAndBusinessUnitData, cheeseTheLogo, setBusinessUnit, isLoading, matchIntakeComplete, matchRoot])


  return (
    <Routes>
      <Route element={<LayoutRoute alert={alert} businessUnit={businessUnit} />}>
        <Route index="true" path=":clinicUniqueId" element={<Intake />} />
        <Route path='/intakeComplete/:clinicUniqueId' element={<IntakeComplete />} />
        <Route exact path='/intakeComplete' element={<ErrorClinic />} />
        <Route exact index="true" path="/" element={<ErrorClinic />} />
      </Route>
      {/* {AppRoutes.map((route, index) => {
        const { element, ...rest } = route;
        return <Route key={index} {...rest} element={element} />;
      })} */}
    </Routes>
  )
}
